import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'icon-search',
  templateUrl: './icon-search.component.html',
  styleUrls: ['./icon-search.component.scss'],
})
export class IconSearchComponent  implements OnInit {
  @Input() size :number = 20;
  constructor() { }

  ngOnInit() {}

}
